module.exports = __webpack_public_path__ + "product/icon-zoom-grey-88dceaa9056fb6fb12b4295bd3339034.svg";